export default {
    cloud_name: 'ampcome',
    upload_preset: 'rd2yhegq'
};


// WEBPACK FOOTER //
// ./src/app/shared/config/cloudinary.config.ts